(function($) {

	'use strict';

	var init = function() {
		ratioVideo();

		if($('body main').hasClass('partner')) {
			managePartnerFilter()
		}

		$(document).on('click', 'a[href^="#"]', function (event) {
			event.preventDefault();

			$('html, body').animate({
				scrollTop: ($($.attr(this, 'href')).offset().top - 250)
			}, 500);
		});

		stickyButtons();

	};

	var stickyButtons = function() {

		var delta = 2;

		if($('body').hasClass('home')) {
			delta = 1.3;
		}

		$(window).scroll(function() {
			$('.sticky-button').each(function(index) {
				if($(window).scrollTop() < (($(this).offset().top / delta) + 128 - $(window).scrollTop() - (index * 2 * 62))) {
					$(this).removeClass('hide')
				} else {
					$(this).addClass('hide')
				}
			})
		}).scroll()
	}

	var ratioVideo = function(){

		$(window).resize(function(){

			var videoWidth = $('.contentVideo iframe').outerWidth();

			$('.contentVideo iframe').height( (videoWidth / 16) * 9 );
			
		}).resize();
		
	};

	var managePartnerFilter = function() {
		$('#partner__filter__select').on('change', function() {
			var href = window.location.href.split("?")[0]
			if(this.value) {
				href += "?spe=" + this.value
			} 
			window.location.href = href
		})
	}

	$(document).ready(function() {
		init();
	});

})(jQuery);
